<template>
  <div class="ui mini modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="play icon"></i>
      {{ $t("start bulk process") }}
    </div>
    <div class="content">
      <div class="description" style="width: 100% !important">
        <div class="ui form" v-bind:class="{ loading: is_loading }">
          <div class="field">
            <label>{{ $t("start scheduled date") }}</label>
            <div class="ui calendar" ref="scheduled_date">
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input type="text" />
              </div>
            </div>
          </div>
          <div class="ui blue fluid icon button" @click="query_database">
            <i class="database icon"></i>
            {{ $t("query from database") }}
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <!-- <div class="ui green icon right labeled button" @click="save">
        <i class="play icon"></i>
        {{ $t("start") }}
      </div> -->
    </div>
  </div>
</template>

<script>
import {
  enterprise_setup,
  local_api,
  error_toast,
  success_toast,
} from "@/utils";
import filters from "@/filters";
// import moment from "moment";

export default {
  name: "VisalinkGeneratorImportModalIndex",
  filters: filters,
  components: {},
  props: {},
  data() {
    return {
      form: undefined,
      scheduled_date: "",
      is_loading: false,
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    show_modal() {
      let vm = this;

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            window.jQuery(vm.$refs.scheduled_date).calendar({
              type: "datetime",
              today: true,
              minDate: new Date(),
              onChange(value) {
                vm.scheduled_date = value;
              },
              initialDate: new Date(),
            });
            vm.scheduled_date = window
              .jQuery(vm.$refs.scheduled_date)
              .calendar("get date");
          },
          onHide() {
            window.jQuery(vm.$refs.scheduled_date).calendar("clear");
            vm.scheduled_date;
          },
        })
        .modal("show");
    },
    save() {},
    query_database() {
      let vm = this;
      vm.is_loading = true;
      local_api(vm, "post", "/visalink_generator/bulk/do-import", {
        d: vm.scheduled_date,
      })
        .then(() => {
          success_toast(vm.$t("import succedded"));
          vm.$emit("import_succedded");
          window.jQuery(vm.$refs.modal).modal("hide");
        })
        .catch((err) => {
          error_toast(err);
        })
        .finally(() => {
          vm.is_loading = false;
        });
    },
  },
  mounted() {},
};
</script>
